import React, { useEffect } from "react";
import {
  Backdrop,
  Button,
  CustomInput,
  CustomSelect,
  FormFieldSet,
  LogoLoader,
  NewTable,
  NewTableAdv,
  useFormHandler,
} from "../../../../../components";
import {
  dateFormator,
  // getvendorId,  // omkar commented this vite issue
  mapTableRows,
} from "../../../../../utils";
import { openinvoicedata } from "../../../../../assets/data/candidatesData";
import {
  DropDownFilteroptions,
  upcommingpayfrequency,
} from "../../../../../assets/data/projectData";
import { useDispatch, useSelector } from "react-redux";
import {
  clearInvoicesdata,
  getAllInvoicesStart,
} from "../../../../../redux/slices/invoices/invoicesSlice";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { getVendorId } from "../../../../../utils/getClientId";
import {
  clearAccountPayablesData,
  getAccountPayablesStart,
} from "../../../../../redux/slices/accountPayables/accountPayablesSlice";
import dayjs from "dayjs";
const DueInvoices = ({ vendorId }) => {
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.accountpayables?.data || 0;
  const { loading, error, accountPayables } = useSelector(
    (state) => state.accountPayables
  );
  console.log("allIncoices", accountPayables);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Search: "",
    InvoiceDate: "",
  });
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10
    // (newPage, newLimit) => {
    //   dispatch(
    //     getClientsStart({
    //       page: newPage,
    //       limit: newLimit,
    //       filter: {},
    //       sort: { uiid: -1 },
    //       // sort: { uiid: 1 },
    //       ret: "uiid businessName generalInfo email contact placements jobCode recordStatus",
    //       ref: "PlacementWithEmp",
    //       incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
    //     })
    //   );
    // }
  );
  useEffect(() => {
    if (vendorId) {
      dispatch(
        totalCountStart({
          collection: "invoices",
          coll: "Invoice",
          filters: {
            vendorId: {
              type: "NONE",
              value: vendorId,
            },
            dueDate: { type: "LT", value: dayjs().startOf("day") },
          },
        })
      );
      dispatch(
        getAccountPayablesStart({
          limit,
          page,
          filters: {
            search: {
              type: "SEARCH",
              value: formData.Search,
            },
            vendorId: {
              type: "NONE",
              value: vendorId,
            },
            dueDate: { type: "LT", value: dayjs().startOf("day") },
          },
          // ret:"uiid"
          ret: "invoiceNum employeeId vendorId invoiceDate shippedDate dueDate amounts currency dueDate uiid memo qbSync",
          ref: "Vendor Employee",
          incl: ["businessName uiid", "firstName lastName"],
        })
      );
    }
    return () => {
      dispatch(clearAccountPayablesData());
    };
  }, [vendorId, limit, page, formData.Search]);

  const tableData2 = accountPayables?.data?.map((item) => ({
    invoiceNumber: item?.invoiceNum || "",
    employee:
      `${item?.employeeId[0]?.firstName || ""} ${
        item?.employeeId[0]?.lastName || ""
      }` || "",
    client: `${item?.vendorId?.businessName || ""}` || "",
    vendorId: getVendorId(item?.vendorId?.uiid),
    invoiceDate: dateFormator(item?.invoiceDate),
    shippedDate: dateFormator(item?.invoiceDate),
    invoiceDueDate: dateFormator(item?.dueDate),
    // invoicedAmount: item?.amounts?.invoiced ? `${item?.amounts?.invoiced} USD` : "",
    invoicedAmount: item?.amounts?.billed ? `${item?.amounts?.billed} USD` : "",
    // receivedAmount: item?.amounts?.received ? `${item?.amounts?.received} USD` : "",
    receivedAmount: item?.amounts?.paid ? `${item?.amounts?.paid} USD` : "",
  }));

  const tableData = openinvoicedata;
  const columns = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
    },
    {
      key: "employee",
      label: "Employee",
    },
    {
      key: "client",
      label: "Client",
    },
    {
      key: "vendorId",
      label: "Client ID",
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
    },
    {
      key: "shippedDate",
      label: "Shipped Date",
    },
    {
      key: "invoiceDueDate",
      label: "InvoiceDueDate",
    },
    {
      key: "invoicedAmount",
      label: "Invoiced Amount",
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
    },
  ];
  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(tableData2, columns);
  return (
    <>
      {/* <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop> */}
      <NewTableAdv
        rows={mappedRows}
        columns={columns}
        showSlNo
        totalCount={totalCount}
        serverPagination={true}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: false,
          filter: true,
          download: false,
          add: [
            {
              component: (
                <div className="flex gap-3">
                  <div className="min-w-[200px] mt-0.5">
                    <FormFieldSet
                      type="text"
                      title="   "
                      placeholder=" Invoice No,Client,Employee"
                      value={formData.Search}
                      onChange={(value) => handleChange("Search", value)}
                      size="sm"
                    />
                  </div>
                  <div className="min-w-[200px]">
                    <FormFieldSet
                      type="select"
                      title="Invoice Date"
                      placeholder="Select InvoiceDate"
                      value={formData.InvoiceDate}
                      onChange={(value) => handleChange("InvoiceDate", value)}
                      options={DropDownFilteroptions}
                      size="sm"
                    />
                  </div>
                  <div className="flex justify-end items-end mb-1.5">
                    <Button title="Search" size="sm" />
                  </div>
                </div>
              ),
            },
          ],
        }}
      />
    </>
  );
};

export default DueInvoices;
